// extracted by mini-css-extract-plugin
export default {"issue":"GgpJZtterimWIKWnK3od"};